import { defineComponent as o, createElementBlock as r, openBlock as t, normalizeClass as c, createBlock as l, createCommentVNode as s, unref as n } from "vue";
import { ScalarIconCheck as a } from "@scalar/icons";
const u = /* @__PURE__ */ o({
  __name: "ScalarListboxCheckbox",
  props: {
    selected: { type: Boolean },
    multiselect: { type: Boolean }
  },
  setup(d) {
    return (e, i) => (t(), r("div", {
      class: c(["flex size-4 items-center justify-center p-0.75", [
        e.selected ? "bg-c-accent text-b-1" : "text-transparent shadow-border",
        e.multiselect ? "rounded" : "rounded-full"
      ]])
    }, [
      e.selected ? (t(), l(n(a), {
        key: 0,
        class: "size-3",
        weight: "bold"
      })) : s("", !0)
    ], 2));
  }
});
export {
  u as default
};
